import { useIdleTimer } from 'react-idle-timer';

const IdleCheck = ({ timeout, userToken, handleLogoutIdle }) => {
  const onIdle = () => {
    if (!userToken) {
      return;
    }

    handleLogoutIdle();
  };

  useIdleTimer({ timeout, onIdle, startOnMount: true });

  return null;
};

export default IdleCheck;
